import type { PostgrestError } from "@supabase/supabase-js";

type SupabaseErrorLike = Partial<Pick<PostgrestError, "code" | "message" | "details" | "hint">>;

function asSupabaseError(error: unknown): SupabaseErrorLike {
  if (typeof error === "object" && error !== null) return error as SupabaseErrorLike;
  return { message: error instanceof Error ? error.message : undefined };
}

export function logSupabaseError(context: string, error: unknown) {
  if (!import.meta.env.DEV) return;
  const details = asSupabaseError(error);
  console.error(`[Supabase] ${context}`, {
    code: details.code ?? null,
    message: details.message ?? null,
    details: details.details ?? null,
    hint: details.hint ?? null,
  });
}

export function readableSupabaseError(error: unknown, fallback = "Something went wrong.") {
  const details = asSupabaseError(error);
  const message = details.message ?? "";
  if (!message) return fallback;
  if (message.includes("duplicate key")) return "That value is already in use for this tenant.";
  if (message.includes("row-level security")) return "You do not have permission to perform this action.";
  if (message.includes("foreign key")) return "The selected related record is no longer available.";
  return message || fallback;
}
